module.exports = __webpack_public_path__ + "static/media/logo3.c3c75c2a.webp";